import React from 'react';
import { MobileOutlined, WechatOutlined, AppstoreOutlined, MailOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import StatisticalItem from './StatisticalItem';
import { number_to_price } from 'helper/common';

const MessagingPlatformStatistics = ({ statisticalData }) => {
  const { t: translation } = useTranslation();

  const calculatePercentage = (value, total) => {
    let percentage = ((value / total) * 100) || 0;
    return Number(percentage.toFixed(2));
  }

  return (
    <div className='col-12 col-lg-12 mb-3'>
      <p className='text-normal fw-semibold '>
        <span>Tổng số lượng tin đã gửi:</span>{' '}
        <span className='fw-bold' style={{color:"#1890FF"}}>{number_to_price(statisticalData.messages?.total)}</span>
      </p>
      <p className='text-normal fw-semibold'>
        <span>Tổng số lượng tin đã gửi thành công:</span>{' '}
        <span className='fw-bold' style={{color:"#52C41A"}}>{number_to_price(statisticalData.messages?.totalSuccess)}</span>
      </p>
      <p className='text-normal fw-semibold '>
        <span>Tổng chi phí:</span>{' '}
        <span className='fw-bold' style={{color:"#d48806"}}>{number_to_price(statisticalData.messages?.totalPrice)} vnđ</span>
      </p>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6 col-xl-3'>
          <StatisticalItem
            bg={"#1890FF"}
            color={"#1890FF"}
            title={translation('sms.apns')}
            icon={<AppstoreOutlined style={{ color: '#1890FF' }} />}
            count={statisticalData.messages?.apns?.totalPrice}
            totalCountByCategory={statisticalData.messages?.apns?.totalSuccess}
            percent={{
              count: calculatePercentage(statisticalData.messages?.apns?.totalSuccess, statisticalData.messages?.apns?.total)
            }}
          />
        </div>
        <div className='col-12 col-md-6 col-lg-6 col-xl-3'>
          <StatisticalItem
            bg={"#52C41A"}
            color={"#52C41A"}
            title={translation('sms.sms')}
            icon={<MobileOutlined style={{ color: '#52C41A' }} />}
            count={statisticalData.messages?.sms?.totalPrice}
            totalCountByCategory={statisticalData.messages?.sms?.totalSuccess}
            percent={{
              count: calculatePercentage(statisticalData.messages?.sms?.totalSuccess,  statisticalData.messages?.sms?.total)
            }}
          />
        </div>
        <div className='col-12 col-md-6 col-lg-6 col-xl-3'>
          <StatisticalItem
            bg={"#d48806"}
            color={"#d48806"}
            title={translation('sms.zns')}
            icon={<WechatOutlined style={{ color: '#d48806' }} />}
            count={statisticalData.messages?.zns?.totalPrice}
            totalCountByCategory={statisticalData.messages?.zns?.totalSuccess}
            percent={{
              count: calculatePercentage(statisticalData.messages?.zns?.totalSuccess, statisticalData.messages?.zns?.total)
            }}
          />
        </div>
        <div className='col-12 col-md-6 col-lg-6 col-xl-3'>
          <StatisticalItem
            bg={"#CF1322"}
            color={"#CF1322"}
            title={translation('sms.email')}
            icon={<MailOutlined style={{ color: '#CF1322' }} />}
            count={statisticalData.messages?.email?.totalPrice}
            totalCountByCategory={statisticalData.messages?.email?.totalSuccess}
            percent={{
              count: calculatePercentage(statisticalData.messages?.email?.totalSuccess, statisticalData.messages?.email?.total)
            }}
          />
        </div>
      </div>
    </div>

  );
};

export default MessagingPlatformStatistics;
